<form class="site-mode-list">
  <mat-form-field>
    <mat-icon matSuffix>arrow_drop_down</mat-icon>
    <input type="text" [placeholder]="placeHolder" aria-label="Number" matInput [formControl]="myControl"
      [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
      <mat-option *ngFor="let siteMode of filteredSiteModes | async" [value]="siteMode">
        {{siteMode?.name}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form>

<!-- <form class="siteMode-list">
  <mat-form-field>
    <mat-select [formControl]="myControl">
      <mat-option *ngFor="let siteMode of companies" [value]="siteMode">
         {{siteMode?.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form> -->